import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Usuario} from "../../models/usuario";
import {ValidatorService} from "../../core/services/validator.service";
import {UsuarioService} from "../../services/usuario.service";
import {MessageService} from "../../core/services/message.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginService} from "../../services/login.service";
import {Perfil} from "../../models/perfil";
import {PerfilService} from "../../services/perfil.service";
import {Estado} from "../../models/estado";
import {Municipio} from "../../models/municipio";
import {EstadoService} from "../../services/estado.service";
import {MunicipioService} from "../../services/municipio.service";
import {DialogUsuarioExternoComponent} from "../dialogs/dialog-usuario-externo/dialog-usuario-externo.component";
import {MatDialog, MatSelectChange} from "@angular/material";
import {GovBrService} from "../../services/govbr.service";
import {isUndefined} from "util";

@Component({
    selector: 'app-cadastro-externo',
    templateUrl: './cadastro-externo.component.html',
    styleUrls: ['./cadastro-externo.component.scss']
})
export class CadastroExternoComponent implements OnInit {

    private usuario: Usuario;
    public perfis: Array<Perfil> = [];
    public form: FormGroup;
    public estados: Array<Estado>;
    public municipios: Array<Municipio>;
    public nomeMunicipio: string;
    public govbr = {
        localStoredUser: this.govbrService.getLocalItem("data"),
    };

    constructor(private usuarioService: UsuarioService,
                private perfilService: PerfilService,
                private loginService: LoginService,
                private govbrService: GovBrService,
                private estadoService: EstadoService,
                private messageService: MessageService,
                private loadingService: NgxSpinnerService,
                private municipioService: MunicipioService,
                private validator: ValidatorService,
                private dialog: MatDialog,
                private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.usuario = new Usuario();
        this.usuario.flg_externo = true;
        this.usuario.txt_situacao = 'pendente';
        this.usuario.cod_perfil = 2;

        this.form = new FormGroup({
            cod_usuario: new FormControl(this.usuario.cod_usuario, []),
            txt_nome: new FormControl(this.usuario.txt_nome, [
                Validators.required,
            ]),
            num_cpf: new FormControl(this.usuario.num_cpf, [
                Validators.required,
                ValidatorService.cpf
            ], [this.validator.existingCpfValidator()]),
            cod_perfil: new FormControl(this.usuario.cod_perfil, []),
            num_telefone: new FormControl(this.usuario.num_telefone, [
                Validators.required,
                ValidatorService.telefone
            ]),
            txt_cargo: new FormControl(this.usuario.txt_cargo, [
                Validators.required
            ]),
            txt_orgao: new FormControl(this.usuario.txt_orgao, [
                Validators.required
            ]),
            txt_unidade: new FormControl(this.usuario.txt_unidade, [
                Validators.required
            ]),
            txt_situacao: new FormControl(this.usuario.txt_situacao, []),
            uf: new FormControl(null, [
                Validators.required
            ]),
            cod_municipio: new FormControl(this.usuario.cod_municipio, [
                Validators.required
            ], [this.validator.existingMunicipioValidator()]),
            num_cnpj: new FormControl(null, [
                Validators.required,
                ValidatorService.cnpj
            ], [this.validator.existingCnpjValidator()]),
            txt_nome_prefeito: new FormControl(null, [
                Validators.required
            ]),
            flg_externo: new FormControl(this.usuario.flg_externo, []),
            txt_email: new FormControl(this.usuario.txt_email, [
                Validators.required,
                Validators.email
            ], [this.validator.existingEmailValidator()])
        });
        this.associate();
        this.carregarEstados();
    }

    carregarEstados(): void {
        this.loadingService.show();
        this.estados = [];
        this.estadoService.listAll().subscribe((estados: Array<Estado>) => {
            this.estados = estados;
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
        this.form.patchValue({
            cod_municipio: null
        });
    }

    carregarMunicipios(uf: string): void{
        this.municipios = [];
        if (uf) {
            this.loadingService.show();
            this.municipioService.listAll(uf).subscribe((municipios: Array<Municipio>) => {
                this.municipios = municipios;
            }, (error) => {
                console.log(error.message);
            });
            this.loadingService.hide();
        }
    }

    selected(event): void {
        let target = event.source.selected._element.nativeElement;
        this.nomeMunicipio = target.innerText.trim();
    }

    save(): void {
        this.form.markAsTouched();
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        if (invalid.length === 0) {
            this.loadingService.show();
            let form = this.form.value as Usuario;
            this.usuarioService.saveExterno(form).subscribe((data: any) => {
                this.loadingService.hide();
                this.messageService.showSuccess('Usuario cadastrado com sucesso !');

                this.router.navigateByUrl("/usuario-externo");
            }, (error) => {
                this.loadingService.hide();
                this.messageService.showResponseError(error);
            });
        } else {
            this.messageService.showAlert("Preencha todos os campos corretamente");
        }
    }

    associate(): void {
        if (this.isGovBr()) {
            this.form.patchValue({
                num_cpf: this.govbr.localStoredUser.sub,
                txt_nome: this.govbr.localStoredUser.name,
                num_telefone: this.govbr.localStoredUser.phone_number,
                txt_email: this.govbr.localStoredUser.email,
            });
        }
    }

    isGovBr(): boolean {
        return this.govbrService.getLocalItem('data') != false;
    }
}
